var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ruler" }, [
    _vm._m(0),
    _c("div", { staticClass: "value-container" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line" }, [
      _c("div", { staticClass: "dot" }),
      _c("div", { staticClass: "center" }),
      _c("div", { staticClass: "dot" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }